import { MainStoreUserEnvironmentState } from 'modules/main/store/ducks/userEnvironment';
import {
  NOTIFICATIONS,
  notificationIsDismissed,
} from 'utils/localNotifications';
import { isNonAdmin, isSalarySurveyCompleted } from 'utils/userEnvironment';

export function promoteSalarySurvey({
  allowDismissal,
  userEnvironment,
}: {
  allowDismissal?: boolean;
  userEnvironment: MainStoreUserEnvironmentState;
}) {
  return (
    (!allowDismissal ||
      !notificationIsDismissed(NOTIFICATIONS.SALARY_SURVEY_CTA)) &&
    userEnvironment.isUserLoaded &&
    userEnvironment.isEnvironmentLoaded &&
    CURRENT_LOCALE === 'en' &&
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    userEnvironment.environment.isUS &&
    // @ts-expect-error TS(2345): Argument of type 'ApiUser | undefined' is not assi... Remove this comment to see the full error message
    !isSalarySurveyCompleted(userEnvironment.user) &&
    (!userEnvironment.user || isNonAdmin(userEnvironment.user))
  );
}

export function promoteSalarySurveySearchAd({
  userEnvironment,
}: {
  userEnvironment: MainStoreUserEnvironmentState;
}) {
  return (
    userEnvironment.isUserLoaded &&
    userEnvironment.isEnvironmentLoaded &&
    CURRENT_LOCALE === 'en' &&
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    userEnvironment.environment.isUS &&
    // @ts-expect-error TS(2345): Argument of type 'ApiUser | undefined' is not assi... Remove this comment to see the full error message
    !isSalarySurveyCompleted(userEnvironment.user)
  );
}
